import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const InputStepOne = () => {
  return (
    <section className="isto-one">
      <div className="isto-nama">
        <input type="text" placeholder="nama depan" />
        <input type="text" placeholder="nama tengah" />
        <input type="text" placeholder="nama belakang" />
      </div>
      <div className="isto-tl">
        <input type="text" placeholder="tanggal lahir" />
      </div>
      <input type="text" placeholder="angkatan" />
      <MyComponent />
    </section>
  );
};
export default InputStepOne;

const MyComponent = () => {
  const [isVerified, setIsVerified] = useState(false);
  const [score, setScore] = useState(null);
  const [error, setError] = useState(null);

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const apiKey = process.env.REACT_APP_RECAPTCHA_API_KEY; // Ganti dengan kunci API Anda
  const projectID = "kirmago-smanrog"; // Ganti dengan ID proyek Anda

  const handleRecaptchaChange = async (token) => {
    if (token) {
      try {
        // Endpoint reCAPTCHA Enterprise API
        const endpoint = `https://recaptchaenterprise.googleapis.com/v1/projects/${projectID}/assessments?key=${apiKey}`;

        // Membuat permintaan ke API Google reCAPTCHA Enterprise
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: {
              token: token,
              expectedAction: "USER_ACTION",
              siteKey: siteKey,
            },
          }),
        });

        const data = await response.json();

        if (response.ok) {
          // Memeriksa hasil analisis risiko
          console.log(data);
          // if (
          //   data.tokenProperties.valid &&
          //   data.tokenProperties.action === "action-name"
          // ) {
          //   setIsVerified(true);
          //   setScore(data.riskAnalysis.score);
          // } else {
          //   setError("Invalid token or action mismatch");
          // }
        } else {
          setError(data.error.message || "Error verifying reCAPTCHA");
        }
      } catch (error) {
        console.error("Error sending token to reCAPTCHA API:", error);
        setError("An error occurred while verifying reCAPTCHA.");
      }
    }
  };

  return (
    <div>
      <h1>Form Verifikasi reCAPTCHA</h1>
      <ReCAPTCHA sitekey={siteKey} onChange={handleRecaptchaChange} />
      {isVerified && <p>sukses</p>}
      {score !== null && <p>Skor reCAPTCHA: {score}</p>}
      {error && <p>Error: {error}</p>}
    </div>
  );
};
